export default __webpack_public_path__ + "static/media/cjs.23afcb6b.png";